// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.remove {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  color: white;\n  font-weight: bold;\n  opacity: 50%;\n  outline: none;\n}\n\nbutton.remove:disabled:hover {\n  opacity: 50%;\n}\n\nbutton.remove:hover {\n  opacity: 85%;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
